<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Jalan" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div class="row mb-5">
            <div class="col-md-12">
              <h5 class="text-uppercase text-info mb-3">
                data pemeriksaan ophthalmic
              </h5>
              <FormRow
                v-for="row in upperForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <hr />
              <h5 class="text-uppercase text-info mt-3"></h5>
              <FormRow
                v-for="row in formKeluhan"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <div class="mb-2" v-if="errorTable">
                <span class="text-danger mb-2"
                  ><i
                    >Data pada tabel ophthalmic di bawah ini kurang lengkap,
                    pastikan sudah terisi semua</i
                  ></span
                >
              </div>
              <TabelOphthalmicEdit
                :data="formSet"
                @handleChange="handleChange"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Data Pemeriksaan
                </button>
                <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/ralan">Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => goBack('/ralan')"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import TabelOphthalmicEdit from "@/components/TabelOphthalmicEdit.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import Alert from "@/components/Alert.vue";
import {
  setPatientIntro,
  setRawatIntro,
  getFullUrl,
  validateForms,
} from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import {
  upperForm,
  formKeluhan,
  today,
  time,
} from "@/data/RalanFormOphthalmicEdit.js";

export default {
  name: "RalanFormOphthalmic",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
    TabelOphthalmicEdit,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: {
        title: "Ubah Data Pemeriksaan Ophthalmic",
        backBtn: "",
        actionBtn: [],
        breadcrumb: [
          { title: "Detail Rawat Jalan", link: "" },
          { title: "Ubah Data Pemeriksaan Ophthalmic", active: true },
        ],
      },
      upperForm: upperForm,
      formKeluhan: formKeluhan,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      errorTable: false,
      idFormOph: "",
      "foto_usg[]_lama": "",
      "foto_iol_master[]_lama": "",
      foto_fundus_lama: "",
      formSet: {
        no_rawat: "",
        id_petugas: "",
        id_petugas_2: "",
        soap: "",
        foto_fundus: "",
        "foto_usg[]": "",
        "foto_iol_master[]": "",
        od_visus_akhir: "",
        os_visus_akhir: "",
        od_ph: "",
        os_ph: "",
        tgl_periksa: today,
        jam_periksa: time,
        keluhan: "",
        od_visus: "",
        od_tio: "",
        od_s_lama: "",
        od_c_lama: "",
        od_x_lama: "",
        od_add_lama: "",
        od_s_kor: "",
        od_c_kor: "",
        od_x_kor: "",
        od_add_kor: "",
        od_catatan: "",
        os_visus: "",
        os_tio: "",
        os_s_lama: "",
        os_c_lama: "",
        os_x_lama: "",
        os_add_lama: "",
        os_s_kor: "",
        os_c_kor: "",
        os_x_kor: "",
        os_add_kor: "",
        os_catatan: "",
      },
      od_visus_l: "",
      od_visus_r: "",
      os_visus_l: "",
      os_visus_r: "",
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      this.errors = [];
      let formData = new FormData();
      var self = this;
      // let body="";
      let { forms, validity } = validateForms(
        this.formSet,
        [this.upperForm, this.formKeluhan],
        this,
        false
      );
      let valid = validity;
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (
            !(
              key == "od_visus_l" ||
              key == "od_visus_r" ||
              key == "os_visus_l" ||
              key == "os_visus_r"
            )
          ) {
            // if (self.formSet[key]) {
            formData.append(key, self.formSet[key]);
            // }
            // body+=`&${key}=${self.formSet[key]}`;
          }
        });
        console.log(formData.get("id_petugas_2"));
        try {
          let result = await this.$store.state.HTTP.post(
            `/ralan/pemeriksaan/ophthalmic/${this.idFormOph}`,
            formData
          );
          console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              that.$router.push(`/ralan/detail/${that.$route.params.id}`);
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      //console.log(e.target.name+':'+e.target.value);
      if (
        e.target.name == "od_visus_l" ||
        e.target.name == "od_visus_r" ||
        e.target.name == "os_visus_l" ||
        e.target.name == "os_visus_r"
      ) {
        this[e.target.name] = e.target.value;
        this.formSet[e.target.name] = e.target.value;
      } else {
        if (e.target.type == "file") {
          if (e.target.files && e.target.files.length) {
            this.formSet[e.target.name] = e.target.files[0];
          }
        } else {
          // console.log(e.target.value);
          this.formSet[e.target.name] = e.target.value;
        }
        //console.log(e.target.name+':'+e.target.value);
      }
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.upperForm, this.formKeluhan].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (column.type == "file" || column.type == "image") {
              if (self.formSet[column.name] != self[column.name + "_lama"]) {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                  // column.key=Math.random();
                  self.formKeluhan.map((item) => {
                    item.columns = item.columns.map((column) => {
                      return column;
                    });
                    return item;
                  });
                };
                reader.readAsDataURL(self.formSet[column.name]);
              }
            }
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              // //console.log(column);
              if (column.regex) {
                //console.log(column.regex);
                if (
                  String(self.formSet[column.name] || "").match(column.regex)
                ) {
                  column.error = "";
                } else {
                  column.error = column.regexError;
                  valid = false;
                }
              } else {
                column.error = "";
              }
            }
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });

      this.upperForm = forms[0];
      this.formKeluhan = forms[1];

      let oph = this.formSet;
      if (
        !(
          oph["od_visus"] &&
          oph["od_tio"] &&
          oph["od_s_lama"] &&
          oph["od_c_lama"] &&
          oph["od_x_lama"] &&
          oph["od_add_lama"] &&
          oph["od_s_kor"] &&
          oph["od_c_kor"] &&
          oph["od_x_kor"] &&
          oph["od_add_kor"] &&
          oph["os_visus"] &&
          oph["os_tio"] &&
          oph["os_s_lama"] &&
          oph["os_c_lama"] &&
          oph["os_x_lama"] &&
          oph["os_add_lama"] &&
          oph["os_s_kor"] &&
          oph["os_c_kor"] &&
          oph["os_x_kor"] &&
          oph["os_add_kor"]
        )
      ) {
        //console.log(oph["od_visus"]);
        //console.log(oph["os_visus"]);
        valid = false;
        this.errorTable = true;
      } else {
        this.errorTable = false;
      }

      //console.log(self.formSet);
      return valid;
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          this.upperForm[0].columns[2].options = result.data.data.map(
            (item) => {
              return { value: item.id, label: item.nama };
            }
          );
          this.upperForm[0].columns[3].options = this.upperForm[0].columns[2].options;
          this.upperForm[0].columns.splice(2, 1, this.upperForm[0].columns[2]);
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    displayData: async function(data) {
      let self = this;
      if (data.foto_usg && data.foto_usg.length) {
        data["foto_usg[]"] = data.foto_usg[data.foto_usg.length - 1].foto;
      }
      if (data.foto_iol_master && data.foto_iol_master.length) {
        data["foto_iol_master[]"] =
          data.foto_iol_master[data.foto_iol_master.length - 1].foto;
      }
      this.idFormOph = data.id;
      Object.keys(this.formSet).forEach(function(key) {
        if (
          ["foto_usg[]", "foto_iol_master[]", "foto_fundus"].indexOf(key) >
            -1 &&
          data[key]
        ) {
          var url;
          url = getFullUrl(self.$store.state.baseStorageURL, data[key]);
          //console.log('url>>');
          //console.log(url);
          self[key + "_lama"] = url;
          self.formSet[key] = url;
        } else {
          self.formSet[key] = data[key];
        }
      });
      this.updateForm();
    },
    updateForm() {
      let self = this;
      let forms = [this.upperForm, this.formKeluhan].map(function(form) {
        form = form.map(function(row, index) {
          row.columns = row.columns.map(function(column) {
            if (
              (self.formSet[column.name] &&
                self.formSet[column.name] != null &&
                self.formSet[column.name] != "null") ||
              self.formSet[column.name] == 0
            ) {
              if (
                ["file", "image"].indexOf(column.type) > -1 &&
                self.formSet[column.name] != self[column.name + "_lama"]
              ) {
                // column.value = '';
                self.updateImage(
                  self.formSet[column.name],
                  column,
                  self.formKeluhan,
                  index
                );
              } else {
                column.value = self.formSet[column.name];
              }
              //console.log("//column.value"); //console.log(column.name+':'+self.formSet[column.name]);
              //console.log(column.value); //console.log(column.name+':'+self.formSet[column.name]);

              //console.log("//column.value"); //console.log(column.name+':'+self.formSet[column.name]);
              //console.log(column.name+':'+column.value);
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.formKeluhan = forms[1];
      //console.log(this.formKeluhan);
    },
    updateImage: async function(file, column, form, rowIndex) {
      column.value = await new Promise((resolve) => {
        var reader = new FileReader();
        reader.onload = (e) => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      ////console.log(column.value);
      ////console.log(this.leftForm);
      form.splice(rowIndex, 1, form[rowIndex]);
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.backBtn = "/ralan/detail/" + this.$route.params.id;
    this.data.breadcrumb[0].link = "/ralan/detail/" + this.$route.params.id;
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}?darurat=0`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        if (result.data.rln_periksa_oph) {
          if (result.data.jen_periksa == "Kontrol Lanjutan") {
            this.formKeluhan[2].columns[1].type = "textarea";
          } else {
            this.formKeluhan[2].columns[1].type = "hidden";
          }
          this.displayData(result.data.rln_periksa_oph);
        } else {
          this.$router.push(`/ralan/form-ophthalmic/${this.$route.params.id}`);
        }
        this.formSet["no_rawat"] = result.data.no_rawat;
        //console.log(this.formSet['no_rawat']);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    this.fetchNurses();
  },
};
</script>
